import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageUploadTiles } from '../-components/PageUploadTiles'
import { useCoreUploadTiles } from '../-hooks/useCoreUploadTiles'
import { OPERATIONS_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/operations/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation('uploads')
  const tiles = useCoreUploadTiles(OPERATIONS_UPLOAD_TYPES)

  return (
    <PageUploadTiles
      tiles={tiles}
      header={t('uploadData.operations.title')}
      description={t('uploadData.operations.description')}
    />
  )
}
